import { BlockCreateInvoiceActionReason } from '../../enums/blockCreateInvoiceActionReason'
import type { Quote } from '../../types/quotes/quote'
import { getQuoteRegularInvoiceDraft } from './getQuoteRegularInvoiceDraft'

export const getBlockCreateDepositInvoiceActionReason = (
  quote?: Quote,
): BlockCreateInvoiceActionReason.RegularInvoiceDraftExists | undefined =>
  getQuoteRegularInvoiceDraft(quote)?.invoiceDraftId
    ? BlockCreateInvoiceActionReason.RegularInvoiceDraftExists
    : undefined
